import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetch_other_projects } from '@store/otherProjects.slice';
import WorksList from '@components/WorksList';

const OtherProjects = () => {
  const { other_projects, is_fetching_other_projects } = useSelector(
    (state) => state.other_projects,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (other_projects.length === 0) {
      fetch();
    }
  }, []);

  const fetch = async () => {
    if (!is_fetching_other_projects) {
      await dispatch(fetch_other_projects());
    }
  };

  const OtherProjectsComponentsList = useMemo(() => {
    return (
      <WorksList
        works={other_projects}
        is_fetching_works={is_fetching_other_projects}
        fetch={fetch}
        title="Morus Project"
        path="other-projects"
      />
    );
  }, [other_projects]);

  return <>{OtherProjectsComponentsList}</>;
};

export default OtherProjects;
